import _ from '../utils'
import FORM_CHECKBOX_GROUP_CONFIG from './config'

class FormCheckboxGroupClass {
    constructor( group ) {
        this.DOM = {
            group: group,
            checkboxs: _.selectAll( 'input[type="checkbox"]', group ),
            required: _.select( '.required', group )
        }

        this.checkeds = []

        this.init()
    }

    init() {
        this._checkeds()
        this._listeners()
    }

    _listeners() {
        this.DOM.checkboxs.forEach( ( checkbox ) => { checkbox.addEventListener( 'change', this._checkeds.bind( this ) ) })
    }

    _checkeds() {
        // Restart checkeds array
        this.checkeds = []

        // Push checked checkboxs to array
        this.DOM.checkboxs.forEach( ( checkbox ) => {
            checkbox.checked ? this.checkeds.push( checkbox ) : null
        })

        // Require complai if one radios is checked
        this.checkeds.length > 0 ? this.DOM.required.value = 'true' : this.DOM.required.value = ''
    }
    
}

const FORM_CHECKBOX_GROUPS = []
FORM_CHECKBOX_GROUP_CONFIG.groups.forEach( ( group ) => { new FormCheckboxGroupClass( group ) })